var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgChevronRightOutline = function SvgChevronRightOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.586 12L8.293 4.707a1 1 0 011.414-1.414l8 8a1 1 0 010 1.414l-8 8a1 1 0 01-1.414-1.414L15.586 12z",
    fill: "#023F80"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjU4NTggMTJMOC4yOTI4OSA0LjcwNzExQzcuOTAyMzcgNC4zMTY1OCA3LjkwMjM3IDMuNjgzNDIgOC4yOTI4OSAzLjI5Mjg5QzguNjgzNDIgMi45MDIzNyA5LjMxNjU4IDIuOTAyMzcgOS43MDcxMSAzLjI5Mjg5TDE3LjcwNzEgMTEuMjkyOUMxOC4wOTc2IDExLjY4MzQgMTguMDk3NiAxMi4zMTY2IDE3LjcwNzEgMTIuNzA3MUw5LjcwNzExIDIwLjcwNzFDOS4zMTY1OCAyMS4wOTc2IDguNjgzNDIgMjEuMDk3NiA4LjI5Mjg5IDIwLjcwNzFDNy45MDIzNyAyMC4zMTY2IDcuOTAyMzcgMTkuNjgzNCA4LjI5Mjg5IDE5LjI5MjlMMTUuNTg1OCAxMloiIGZpbGw9IiMwMjNGODAiLz4KPC9zdmc+Cg==";
export { SvgChevronRightOutline as ReactComponent };